import style from './InventoryTable.scss';

type InventoryTableProps = {
  children(styles: typeof style): JSX.Element;
};

const InventoryTable = ({ children }: InventoryTableProps) => children(style);

export default InventoryTable;
